import { Component, Input, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, Output } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';

import {SlideshowService} from '../slideshow.service';
import {ApiService} from '../../shared/api.service';
import {ImagesService} from '../../shared/images.service';

@Component({
    selector: 'slide-component',
    templateUrl: 'slide.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideComponent {
    canEdit = false;
    tempImageGroupIds = [];

    @Input() slide;
    @Input() i;
    @Input() caption; // this triggers a caption change from parent

    @Output() resultsChanged = new EventEmitter();

    constructor(
        private api: ApiService,
        public cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private images: ImagesService, 
        private route: ActivatedRoute,
        private slideshow: SlideshowService
    ) {
        let user = api.getProp('user');
        if( user.role == 'administrator' || user.role == 'editor' ) {
            this.canEdit = true;
        }
        this.slideshow.slidesLoaded.subscribe(index => {
            let segments = this.route.snapshot['_urlSegment'].segments;
            if( segments.length == 3 ) {
                let slideIndex = parseInt(segments[2].path);
                this.slideshow.setSlide(slideIndex);
            }
        });
        this.slideshow._locked.subscribe(() => {
            this.cdr.markForCheck();
        });
        this.slideshow.featuredImageChange.subscribe(() => {
            this.cdr.markForCheck();
        });
        this.images.imagesChange.subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    getContent(content) {
        let html = '';
        if( Array.isArray(content) ) {
            const texts = [];
            content.forEach(item => {
                texts.push('<p>' + item.text + '</p>');
            });
            html = texts.join('');
        } else {
            return '<span>' + content + '</span>';
        }
        return html;
    }
    addContent(slide, i, index, content) {
        let nextIndex = index + 1;
        slide.content.splice(nextIndex, 0, content);
        this.moveFocus('#content-' + i + '-' + nextIndex);
    }
    removeContent(slide, i, index, remove) {
        if( slide.content[index].text == '' || remove ) {
           slide.content.splice(index, 1);
           let prevIndex = index - 1;
           this.moveFocus('#content-' + i + '-' + prevIndex);
        }        
    }
    moveFocus(selector) {
        setTimeout(() => {
            let richtext = document.querySelector(selector + ' .medium-editor-element') as HTMLElement;
            if( richtext ) {
                richtext.focus();
            }
        }, 150);
    }
    addResult(slide) {
        slide.content.push({text: '', title: '', level: ''});
        this.slideshow.calculateTiers();
        this.emitResults();
    }
    resetBuckets(resultIndex) {
        const slides = this.slideshow.slides;
        for(var i = 0; i < slides.length; i++) {
            const content = slides[i].content;
            for(var j = 0; j < content.length; j++) {
                if( content[j].bucket == resultIndex ) {
                    content[j].bucket = 0;
                }
            }
        }
    }
    emitResults() {
        this.resultsChanged.emit(this.slide);
    }
    removeResult(slide, i) {
        if( this.slideshow.assignment.quizType == 'personality' ) {
            this.resetBuckets(i);
            this.emitResults();
        }
        slide.content.splice(i, 1);
        this.slideshow.calculateTiers();
    }
    getScore(i) {
        let text = '';
        let tier = this.slideshow.tiers[i];
        if( tier ) {
            text = ' (' + tier.min + '-' + tier.max + ')';
        }
        return text;        
    }
    addToSearch(terms, i) {
        this.slideshow.slides[i].search = terms;
    }
    contentAdded(e, i) {
        let nextId = 'me' + (i + 1);
        setTimeout(() => {
            let nodes = document.getElementsByName(nextId);
            if( nodes.length ) {
                let el = nodes[0].parentElement.querySelector('.medium-editor-element') as HTMLElement;
                el.focus();
            }
        }, 50);
    }
    getWordCount(content) {
        let clean = this.slideshow.cleanContent;
        let str = '';
        for(var i = 0; i < content.length; i++) {
            let cleanStr = clean(content[i].text).trim();
            if( cleanStr !== '' ) {
                str += ' ' + cleanStr;
            }
        }
        return str != '' ? str.split(' ').length - 1 : 0;
    }
    toggle(item, slide) {
        slide[item] = !slide[item];
    }
    setQuizResultImage(e, content, i) {
        if( e.images.length == 0 ) {
            return;
        }
        if( e.mobile ) {
            content[i].imageMobile = e.images[0];
        } else {
            content[i].image = e.images[0]; 
        }
        this.cdr.markForCheck();
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/slide/slide.component.ts